import { TradeOrgPages } from "../types/tradeorgPages.ts";
import OrgLinks from "./components/OrgLinks.tsx";
import Text from "./components/Text.tsx";
import Title from "./components/Title.tsx";
import { Layout } from "./Layout.tsx";

const Mgf = () => {
  const pageName = TradeOrgPages.MGF;
  return (
    <Layout
      left={
        <>
          <Title title="Fordeler med MGF" subTitle="Dette produktet/tjenesten leveres av et medlem av MGF" />
          <div className="mt-40 pb-40">
            <p className="mb-0">
              Maskingrossisternes Forening (MGF) er bransjeforeningen for grossister og importører av maskiner og
              teknisk utstyr til industri, logistikk samt bygg- og anleggsbransjen. Foreningen ble etablert i 1913 og
              representerer i dag bredden av seriøse leverandører i det norske markedet.
            </p>
            <Text text="MGF arbeider for gode og rettferdige rammevilkår for alle som leverer maskiner og utstyr til norsk næringsliv. Når du kjøper et produkt eller en tjeneste fra et MGF-medlem, vet du at leverandøren er tilknyttet en organisasjon som jobber for kvalitet, trygghet, kompetanse og profesjonelle standarder i bransjen." />
            <Text text="For å være medlem i MGF må virksomheten ha drevet virksomhet i Norge i minimum 2 år, ha nasjonalt salgs- og serviceapparat og ikke som virksomhet eller ved personer med bestemmende innflytelse ha vært dømt for alvorlige straffbare forhold eller ha vist adferd som gir grunn til å reise tvil om integritet og yrkesutøvelse." />

            <h4 className="t4 mt-40 mb-0">Eid av og for bransjen</h4>
            <Text text="MGF er en ikke-kommersiell forening som eies av medlemmene og har en lang historie som bransjesamler. Foreningen arbeider nasjonalt og internasjonalt for å sikre medlemsbedriftenes interesser gjennom dialog med myndigheter, samarbeidspartnere og europeiske organisasjoner som CECE og FEM." />

            <h4 className="t4 mt-40 mb-0">Strategiske satsningsområder</h4>
            <Text text="MGF jobber aktivt med temaer som er viktige både for bransjen og samfunnet:" />
            <ul className="list-outside list-disc pl-16 mt-8 mb-0">
              <li>Bærekraft og nullutslippsteknologi</li>
              <li>Rekruttering og kompetanseutvikling</li>
              <li>
                Sikkerhet og beredskap, inkludert oppdatert kunnskap om teknologi og samfunnskritisk infrastruktur
              </li>
            </ul>

            <h4 className="t4 mt-40 mb-0">Fagmesser og utvikling</h4>
            <Text text="MGF arrangerer også store bransjemesser som Vei og Anlegg og SMART industri, som bidrar til å styrke kunnskap, nettverk og innovasjon i markedet." />
          </div>
        </>
      }
      right={<OrgLinks pageName={pageName} />}
    />
  );
};

export default Mgf;
